/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import CanvasActions from "../../../redux/actions/canvasActions";
import canvasHelper from "../utils/canvas";
import { validateCropDimention } from "../../../helpers/validatorHelper";
import { checkPositionMouse, getBorderCrop } from "../utils/helpers";
import AnalyticsSender from "../../../helpers/analyticsSender";
const analyticsSender = new AnalyticsSender();

const saveCropResize = (
  width,
  height,
  mouseX,
  mouseY,
  dispatch,
  setCropDimensions,
  setCanvasInputValue,
  setCropPosition
) => {
  dispatch(setCropDimensions(width, height));

  setCanvasInputValue({
    width: width,
    height: height,
  });

  dispatch(setCropPosition(mouseX, mouseY));
};

const changeCropPosition = (
  cropDimensions,
  cropPosition,
  movement,
  resizeProportionWidth,
  resizeProportionHeight,
  canvasWidth,
  canvasHeight,
  dispatch,
  setCropPosition,
  setChange
) => {
  let positionX = cropPosition.x + movement.movementX * resizeProportionWidth;
  let positionY = cropPosition.y + movement.movementY * resizeProportionHeight;

  positionX = Math.floor(positionX) < 0 ? 0 : positionX;
  positionX =
    Math.floor(positionX) + cropDimensions.width > canvasWidth
      ? canvasWidth - cropDimensions.width
      : positionX;
  positionY = Math.floor(positionY) < 0 ? 0 : positionY;
  positionY =
    Math.floor(positionY) + cropDimensions.height > canvasHeight
      ? canvasHeight - cropDimensions.height
      : positionY;

  dispatch(setCropPosition(positionX, positionY));

  dispatch(setChange());
};

const validationResizeCrop = (
  cropDimensionWidth,
  cropDimensionHeight,
  canvasWidth,
  canvasHeight
) => {
  cropDimensionWidth = cropDimensionWidth < 0 ? 0 : cropDimensionWidth;
  cropDimensionWidth =
    cropDimensionWidth > canvasWidth ? canvasWidth : cropDimensionWidth;
  cropDimensionHeight = cropDimensionHeight < 0 ? 0 : cropDimensionHeight;
  cropDimensionHeight =
    cropDimensionHeight > canvasHeight ? canvasHeight : cropDimensionHeight;

  return { width: cropDimensionWidth, height: cropDimensionHeight };
};

const CanvasCrop = ({
  image,
  imageWidth,
  imageHeight,
  cropDimensions,
  setCropDimensions,
  dispatch,
  cropIsSaveProportions,
  setCropPosition,
  cropPosition,
  canvasRef,
  canvasCropperRef,
  setChange,
  setCanvasInputValue,
}: {
  service: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
  cropDimensions;
  setCropDimensions: Function;
  dispatch: any;
  cropIsSaveProportions: boolean;
  setCropPosition: Function;
  cropPosition: { x: number; y: number };
  canvasRef: any;
  canvasCropperRef: any;
  setChange: Function;
  setCanvasInputValue: Function;
}): JSX.Element => {
  const { canvasImage, canvasFormat, canvasWidth, canvasHeight, changeImage } =
    CanvasActions();

  const [mouseClick, setMouseClick] = useState(false);
  const [resizeEvent, setResizeEvent] = useState([]);
  const [startTouch, setStartTouch] = useState({ x: 0, y: 0 });

  const [isSideResize, setIsSideResize] = useState({
    isTopResize: false,
    isRightResize: false,
    isBottomResize: false,
    isLeftResize: false,
    inCrop: false,
  });

  useEffect(() => {
    if (
      canvasWidth &&
      cropDimensions.width &&
      cropPosition.x === undefined &&
      cropPosition.y === undefined
    ) {
      dispatch(
        setCropPosition(
          canvasWidth / 2 - cropDimensions.width / 2,
          canvasHeight / 2 - cropDimensions.height / 2
        )
      );
    }
  }, [cropDimensions]);

  useEffect(() => {
    const validation = validateCropDimention(
      imageWidth,
      imageHeight,
      cropDimensions.width,
      cropDimensions.height
    );

    if (!validation.isValid) return;

    const context: any = canvasCropperRef.current.getContext("2d");

    const canvasContext = canvasHelper.setContext(context);

    context.clearRect(0, 0, canvasWidth, canvasHeight);

    canvasContext
      .beginPath()
      .addFilter(canvasWidth, canvasHeight, "rgba(0, 0, 0, 0.5)")
      .fill();

    const borderWidth = getBorderCrop(canvasWidth, canvasHeight, true);

    canvasContext
      .beginPath()
      .removeRegionFilter(
        cropPosition.x,
        cropPosition.y,
        cropDimensions.width,
        cropDimensions.height,
        "#338FFF",
        borderWidth
      )
      .fill()
      .beginPath()
      .drawGrid(
        cropPosition.x,
        cropPosition.y,
        cropDimensions.width,
        cropDimensions.height,
        3,
        borderWidth,
        canvasWidth,
        canvasHeight
      )
      .stroke()
      .fill();
  }, [cropDimensions, cropPosition]);

  const cropMove = (e) => {

    const resizeProportionWidth =
      canvasWidth / canvasCropperRef.current.clientWidth;
    const resizeProportionHeight =
      canvasHeight / canvasCropperRef.current.clientHeight;

    const rect = e.target.getBoundingClientRect();

    let cropMousePosition = checkPositionMouse(
      cropPosition.x,
      cropPosition.y,
      cropDimensions.width,
      cropDimensions.height,
      (e.clientX - rect.left) * resizeProportionWidth,
      (e.clientY - rect.top) * resizeProportionHeight,
      getBorderCrop(canvasWidth, canvasHeight, true) * 3
    );

    if (e.type === "touchmove" && e.targetTouches.length > 0) {
      cropMousePosition = checkPositionMouse(
        cropPosition.x,
        cropPosition.y,
        cropDimensions.width,
        cropDimensions.height,
        (e.targetTouches[0].clientX - rect.left) * resizeProportionWidth,
        (e.targetTouches[0].clientY - rect.top) * resizeProportionHeight,
        (e.type === "touchmove" ? 0 : getBorderCrop(canvasWidth, canvasHeight, true) * 3)
      );
    }

    if (JSON.stringify(cropMousePosition) !== JSON.stringify(isSideResize)) {
      setIsSideResize(cropMousePosition);
    }

    if (cropMousePosition.inCrop && mouseClick) {
      if (e.type === "touchmove" && e.targetTouches.length > 0) {
        changeCropPosition(
          cropDimensions,
          cropPosition,
          {
            movementX: startTouch.x === 0 ? 0 : e.targetTouches[0].clientX - startTouch.x,
            movementY: startTouch.y === 0 ? 0 : e.targetTouches[0].clientY - startTouch.y,
          },
          resizeProportionWidth,
          resizeProportionHeight,
          canvasWidth,
          canvasHeight,
          dispatch,
          setCropPosition,
          setChange
        );
        setStartTouch({
          x: e.targetTouches[0].clientX,
          y: e.targetTouches[0].clientY,
        });
      } else {
        changeCropPosition(
          cropDimensions,
          cropPosition,
          e,
          resizeProportionWidth,
          resizeProportionHeight,
          canvasWidth,
          canvasHeight,
          dispatch,
          setCropPosition,
          setChange
        );
      }

      return;
    }

    if (e.type !== "touchmove" && mouseClick) {
      // touch
      let diffDimensionWidth = 0, diffDimensionHeight = 0;

      if (cropMousePosition.isLeftResize || cropMousePosition.isRightResize) {
        diffDimensionWidth = (cropMousePosition.isLeftResize ? -1 : 1) * e.movementX * resizeProportionWidth;
        diffDimensionHeight = (cropMousePosition.isLeftResize ? -1 : 1) * e.movementX * resizeProportionHeight;
      }

      if (cropMousePosition.isTopResize || cropMousePosition.isBottomResize) {
        diffDimensionWidth = (cropMousePosition.isTopResize ? -1 : 1) * e.movementY * resizeProportionWidth;
        diffDimensionHeight = (cropMousePosition.isTopResize ? -1 : 1) * e.movementY * resizeProportionHeight;
      }

      let newCropDimensionWidth = Math.ceil(cropDimensions.width + diffDimensionWidth);
      let newCropDimensionHeight = Math.ceil(cropDimensions.height + diffDimensionHeight);

      if (cropMousePosition.isLeftResize || cropMousePosition.isRightResize) {
        newCropDimensionHeight = !cropIsSaveProportions
          ? cropDimensions.height
          : newCropDimensionHeight;
      }

      if (cropMousePosition.isTopResize || cropMousePosition.isBottomResize) {
        newCropDimensionWidth = !cropIsSaveProportions
          ? cropDimensions.width
          : newCropDimensionWidth;
      }

      const validateCrop = validationResizeCrop(
        newCropDimensionWidth,
        newCropDimensionHeight,
        canvasWidth,
        canvasHeight
      );

      newCropDimensionWidth = validateCrop.width;
      newCropDimensionHeight = validateCrop.height;
      let newMousePositionX = cropPosition.x;
      let newMousePositionY = cropPosition.y;

      if (cropMousePosition.isLeftResize) {
          newMousePositionX = cropPosition.x + e.movementX * resizeProportionWidth < 0
          ? 0
          : 
            newMousePositionX + newCropDimensionWidth <= canvasWidth 
            ? cropPosition.x + e.movementX * resizeProportionWidth 
            : canvasWidth - newCropDimensionWidth; 

      }

      if(cropMousePosition.isTopResize) {
        newMousePositionY = cropPosition.y + (cropDimensions.height - newCropDimensionHeight);
      }

      if ((cropMousePosition.isRightResize || cropMousePosition.isBottomResize) && (newCropDimensionWidth + cropPosition.x >= canvasWidth || newCropDimensionHeight + cropPosition.y >= canvasHeight)) {
        newCropDimensionWidth = cropDimensions.width;
        newCropDimensionHeight = cropDimensions.height;

        if (cropMousePosition.isLeftResize) { 
          newMousePositionX = cropPosition.x;
        }
      }
      
      if ((cropMousePosition.isLeftResize || cropMousePosition.isTopResize) && (newMousePositionX + newCropDimensionWidth >= canvasWidth || newCropDimensionHeight + cropPosition.y >= canvasHeight)) {     
        newCropDimensionHeight = cropDimensions.height;
    
        if(cropMousePosition.isTopResize) {
          newMousePositionY = cropPosition.y;
        } 
      }

      setResizeEvent([...resizeEvent, { change: "width", width: newCropDimensionWidth, height: newCropDimensionHeight }]);
      saveCropResize(newCropDimensionWidth, newCropDimensionHeight, newMousePositionX, newMousePositionY, dispatch, setCropDimensions, setCanvasInputValue, setCropPosition);

      return;
    }
  }
    let canvasCursor: string = "initial";

    if (isSideResize.isLeftResize || isSideResize.isRightResize) {
      canvasCursor = "col-resize";
    } else if (isSideResize.isTopResize || isSideResize.isBottomResize) {
      canvasCursor = "row-resize";
    } else if (isSideResize.inCrop) {
      canvasCursor = "all-scroll";
    }

    return (
      <div className="cropper">
        <canvas
          width={canvasWidth}
          height={canvasHeight}
          ref={canvasRef}
        ></canvas>
        <canvas

          width={canvasWidth}
          height={canvasHeight}
          style={{
            cursor: canvasCursor,
          }}
          ref={canvasCropperRef}
          onMouseUp={() => {
            setMouseClick(false);

            if (resizeEvent.length) {
              const lastEvent = resizeEvent.pop();

              analyticsSender.sendScaleCropper(
                lastEvent.change,
                lastEvent.width,
                lastEvent.height
              );

              setResizeEvent([]);
            }
          }}
          onMouseDown={() => {
            setMouseClick(true);
          }}
          onMouseOver={() => {
            setMouseClick(false);
            if (resizeEvent.length) {
              const lastEvent = resizeEvent.pop();

              analyticsSender.sendScaleCropper(
                lastEvent.change,
                lastEvent.width,
                lastEvent.height
              );

              setResizeEvent([]);
            }
          }}
          onMouseMove={(e) => {
            cropMove(e);
          }}
          onTouchEnd={(e) => {
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            setStartTouch({
              x: 0,
              y: 0,
            });

          }}
          onTouchMove={(e) => {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            setMouseClick(true);
            cropMove(e);
          }}

        ></canvas>
      </div>
    );
  };


  const changeDimensionCropHandler = () => {
   
  }

  export default CanvasCrop;
